module.exports = __webpack_public_path__ + "img/home-github-tabs.3c5e5b3a.png";